export const SCREEN_ORIENTATIONS = ["landscape", "portrait"];
export const FLEET_LIFECYCLE_STATUSES = ["active", "archived"];
export const TIMEZONE_SOURCES = ["screen", "site", "tenant"];
export const DEVICE_LIFECYCLE_STATUSES = [
    "active",
    "revoked",
    "decommissioned",
];
export const DEVICE_CLOCK_CONFIDENCES = ["high", "low", "unknown"];
export const DEVICE_ASSERTION_ISSUER = "digital-signage-player";
export const DEVICE_ENROLLMENT_AUDIENCE = "digital-signage-device-enrollment";
export const DEVICE_ROTATION_AUDIENCE = "digital-signage-device-rotation";
export const DEVICE_TOKEN_AUDIENCE = "digital-signage-device-token";
export const DEVICE_PLAYBACK_OUTCOMES = [
    "completed",
    "failed",
    "interrupted",
    "skipped",
];
export const DEVICE_PLAYBACK_REASON_CODES = [
    "asset_load_failed",
    "asset_corrupt",
    "manifest_replaced",
    "player_stopped",
    "renderer_error",
    "unsupported_media",
    "unknown",
];
const screenOrientationSet = new Set(SCREEN_ORIENTATIONS);
export function isScreenOrientation(value) {
    return screenOrientationSet.has(value);
}
//# sourceMappingURL=fleet.js.map